import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';

@Entity('_conversation_voice_profiles')
@Index(
	'ft_voice_search',
	['name', 'description', 'category', 'accent', 'language', 'voiceId'],
	{ fulltext: true },
)
export class ConversationVoiceProfilesEntity extends BaseEntity {
	@Column({ name: 'name', type: 'varchar', length: 100, nullable: false })
	public name!: string;

	@Column({ name: 'description', type: 'text', nullable: true })
	public description?: string;

	@Column({
		name: 'voice_provider',
		type: 'varchar',
		length: 20,
		default: "'elevenlabs'",
	})
	public voiceProvider!: string;

	@Column({
		name: 'voice_id',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public voiceId?: string;

	@Column({ name: 'category', type: 'varchar', length: 50, nullable: false })
	public category!: string;

	@Column({ name: 'use_case', type: 'varchar', length: 50, nullable: true })
	public useCase?: string;

	@Column({
		name: 'gender',
		type: 'enum',
		enum: ['male', 'female', 'neutral'],
		nullable: true,
	})
	public gender?: 'male' | 'female' | 'neutral';

	@Column({ name: 'language', type: 'varchar', length: 50, nullable: false })
	public language!: string;

	@Column({ name: 'accent', type: 'varchar', length: 50, nullable: false })
	public accent!: string;

	@Column({ name: 'age_range', type: 'varchar', length: 50, nullable: true })
	public ageRange?: string;

	@Column({ name: 'is_favorite', type: 'tinyint', width: 1, default: 0 })
	public isFavorite!: boolean;

	@Column({ name: 'liked_by_count', type: 'int', unsigned: true, default: 0 })
	public likedByCount!: number;

	@Column({ name: 'cloned_by_count', type: 'int', unsigned: true, default: 0 })
	public clonedByCount!: number;

	@Column({ name: 'preview_url', type: 'varchar', length: 500, nullable: true })
	public previewUrl?: string;

	/**
	 * PD-16872 — the tone this voice uses by default ("casual" for Sam), sent
	 * to v4 as a tag. Agents inherit it unless they set their own.
	 */
	@Column({ name: 'speakingDirection', type: 'varchar', length: 80, nullable: true })
	public speakingDirection?: string | null;

	// Relationships
	@OneToMany(() => ConversationAgentEntity, (agent) => agent.voiceProfile)
	public agents!: ConversationAgentEntity[];

	// Indexes
	@Index('idx_category')
	public static categoryIndex: string = 'category';

	@Index('idx_voice_favorite')
	public static favoriteIndex: string = 'is_favorite';

	@Index('idx_owner')
	public static ownerIndex: string = '_owner_userId';

	@Index('idx_voice_provider_voice_id', ['voiceProvider', 'voiceId'], {
		unique: true,
	})
	public static voiceProviderVoiceIdIndex: string = 'voice_provider_voice_id';
}
